import { uniq } from 'lodash';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export type PopUpType = 'Error' | 'Warning' | 'Information' | 'Action Required';
interface Props {
  type: PopUpType;
  contents?: ReactNode[];
  prefix?: string;
  title?: ReactNode;
}

const colorPreference = {
  Warning: {
    main: 'bg-orange-100',
    title: 'bg-orange-200',
  },
  Error: {
    main: 'bg-red-200',
    title: 'bg-red-300',
  },
  'Action Required': {
    main: 'bg-red-200',
    title: 'bg-red-300',
  },
  Information: {
    main: 'bg-blue-200',
    title: 'bg-blue-300',
  },
};

const PopUpContentWrapper: FC<Props> = ({ type, contents, prefix = '', title = '' }) => {
  const { t } = useTranslation();
  const uniqueContents = uniq(contents);

  return uniqueContents?.length ? (
    <div className={`${colorPreference[type].main} w-full rounded-md break-words text-wrap p-1`}>
      <div className={`px-2 py-1 ${colorPreference[type].title} text-left font-bold rounded-md`}>
        {prefix} {t(type)}
      </div>
      {title && <div className="px-2 py-1">{title}</div>}
      <ul className="text-left px-3 py-3 overflow-auto">
        {uniqueContents?.map((content, index) => (
          <li key={index} className="whitespace-pre-wrap mb-2 list-item list-disc ml-4">
            {content}
          </li>
        ))}
      </ul>
    </div>
  ) : (
    <></>
  );
};

export default PopUpContentWrapper;
